/**
 * URL form of a tag group, mirrors EnumActorVideoTagGroup::toSlug, e.g. "Wichsanleitung / JOI" => "wichsanleitung-joi"
 */
export function toTagGroupSlug(tagGroup) {
	return tagGroup
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
}

/**
 * the tag group for the :tagGroup URL value, a single video tag stays as it is
 */
export function getTagGroupFromUrl(urlValue, availableTagGroups) {
	let value = urlValue || '';
	try {
		value = decodeURIComponent(value);
	} catch {
		// malformed escape sequence, keep the raw value
	}

	const slug = toTagGroupSlug(value);

	return (availableTagGroups || []).find((tagGroup) => toTagGroupSlug(tagGroup) === slug) || value;
}
